import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoaundhnagnathcab() {



  const cardData = {
"keyword": "Pune to Aundha Nagnath Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Aundha Nagnath Cab for travelers seeking a safe, affordable, and convenient pilgrimage journey to one of the most sacred Jyotirlinga temples in Maharashtra. Whether you are planning a family pilgrimage, spiritual tour, weekend darshan, group yatra, or senior citizen travel, our taxi service ensures a smooth and stress-free experience. With experienced drivers who are well-versed with long-distance highway routes across Maharashtra, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Aundha Nagnath. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup from Pune, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and spiritually fulfilling journey to Aundha Nagnath.",

"topPlaces": [
  {
    "title": "Aundha Nagnath Jyotirlinga Temple",
    "description":
      "Aundha Nagnath Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and a highly revered pilgrimage site in Maharashtra. It is known for its ancient Hemadpanthi architecture and deep spiritual significance for devotees."
  },
  {
    "title": "Hingoli District Region",
    "description":
      "Aundha Nagnath is located in Hingoli district, a region known for its rural landscapes, agricultural fields, and peaceful environment ideal for spiritual travel."
  },
  {
    "title": "Nanded Spiritual Circuit (Nearby)",
    "description":
      "Nanded is a major nearby pilgrimage center known for Takht Sachkhand Sri Hazur Sahib, attracting Sikh devotees from across India and often included in extended spiritual tours."
  },
  {
    "title": "Parbhani Region Connectivity",
    "description":
      "Parbhani is another nearby district connected to Aundha Nagnath, known for its temples, cultural heritage, and agricultural importance in the Marathwada region."
  },
  {
    "title": "Basmat Road Route",
    "description":
      "The Pune to Aundha Nagnath route via Basmat Road passes through smooth highways, rural Maharashtra landscapes, and peaceful villages, making the long journey comfortable."
  },
  {
    "title": "Akola–Nanded Highway Belt",
    "description":
      "The highway belt connecting Marathwada cities offers steady road conditions, small towns, and agricultural landscapes throughout the journey from Pune."
  },
  {
    "title": "Sant Namdev Spiritual Region",
    "description":
      "The surrounding region of Marathwada is associated with saints and spiritual traditions, adding cultural significance to the pilgrimage journey."
  },
  {
    "title": "Godavari Basin Area",
    "description":
      "The nearby Godavari basin region is known for fertile lands, river systems, and agricultural importance across central Maharashtra."
  },
  {
    "title": "Hingoli Rural Landscapes",
    "description":
      "The Hingoli region around Aundha Nagnath is characterized by peaceful rural scenery, farmlands, and traditional Maharashtrian village life."
  },
  {
    "title": "Marathwada Pilgrimage Route",
    "description":
      "The Pune to Aundha Nagnath cab route passes through the Marathwada region, offering a meaningful spiritual journey across one of Maharashtra’s important cultural and religious belts."
  }
],



services: [
  {
    name: "Pune to Aundha Nagnath Cab",
    description: "Pune to Aundha Nagnath cab service provides reliable transportation for passengers traveling between Pune and Aundha Nagnath with comfortable vehicles and experienced drivers. Vehicles are suitable for long-distance highway travel ensuring smooth and timely journeys for pilgrims, families, tourists, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient Pune to Aundha Nagnath cab reservations."
  },
  {
    name: "Pune to Aundha Nagnath Taxi",
    description: "Pune to Aundha Nagnath taxi service offers dependable transportation for pilgrimage and outstation travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for temple visits, family travel, tourism, and religious journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pune to Aundha Nagnath taxi reservations."
  },
  {
    name: "Cab from Pune to Aundha Nagnath",
    description: "Cab from Pune to Aundha Nagnath service provides comfortable transportation for passengers traveling from Pune to Aundha Nagnath and nearby pilgrimage destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for pilgrims, tourists, and family travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Aundha Nagnath",
    description: "Taxi from Pune to Aundha Nagnath service offers reliable transportation with comfortable vehicles and professional drivers for passengers requiring direct travel between Pune and Aundha Nagnath. Vehicles provide smooth city and highway travel suitable for temple visits, religious tours, sightseeing, and family travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Aundha Nagnath Cab Service",
    description: "Pune to Aundha Nagnath cab service provides dependable transportation solutions for outstation travel between Pune and Aundha Nagnath. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and pilgrimage groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for temple darshan trips, religious tourism, and family spiritual travel. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Pune to Aundha Nagnath Taxi Fare",
    description: "Pune to Aundha Nagnath taxi fare service provides transparent and reliable transportation options for travelers planning budget-friendly travel between Pune and Aundha Nagnath. Travelers can enjoy smooth journeys with experienced drivers familiar with temple routes and highway conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi fare cab reservations."
  },
  {
    name: "Pune to Aundha Nagnath One Way Cab",
    description: "Pune to Aundha Nagnath one way cab service provides economical and comfortable transportation for travelers planning one-side travel between Pune and Aundha Nagnath. Comfortable vehicles ensure smooth highway travel suitable for pilgrimage trips, religious tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Aundha Nagnath Round Trip Taxi",
    description: "Pune to Aundha Nagnath round trip taxi service offers spacious transportation for families and groups traveling between Pune and Aundha Nagnath with return travel options. Vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for pilgrimage outings and temple travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Pune to Aundha Nagnath Cab Booking",
    description: "Pune to Aundha Nagnath cab booking service provides premium transportation for passengers seeking comfortable and reliable pilgrimage travel. Vehicles offer spacious seating, smooth ride quality, and luggage space suitable for religious tourism, temple visits, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cheap Pune to Aundha Nagnath Cab",
    description: "Cheap Pune to Aundha Nagnath cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Aundha Nagnath. Vehicles provide smooth highway travel with comfortable seating and luggage space suitable for one-way and round-trip journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Aundha Nagnath Taxi",
    description: "Best Pune to Aundha Nagnath taxi service offers dependable transportation for passengers planning direct pilgrimage travel between Pune and Aundha Nagnath. Comfortable vehicles ensure smooth highway travel suitable for temple visits, religious tourism, and family spiritual trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Aundha Nagnath Cab",
    description: "Sedan Pune to Aundha Nagnath cab service provides reliable transportation for travelers planning comfortable journeys between Pune and Aundha Nagnath. Sedan vehicles ensure smooth and safe travel suitable for pilgrims, couples, families, and business travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Aundha Nagnath Taxi",
    description: "SUV Pune to Aundha Nagnath taxi service offers comfortable transportation for passengers looking for spacious and reliable travel services between Pune and Aundha Nagnath. SUV vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for pilgrimage groups, family tours, religious travel, and outstation travel requirements. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Aundha Nagnath Cab",
    description: "Innova Pune to Aundha Nagnath cab service provides dependable transportation for passengers planning premium pilgrimage travel between Pune and Aundha Nagnath. Innova vehicles ensure smooth highway travel suitable for temple visits, Jyotirlinga tours, sightseeing trips, and family spiritual vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Temple Cab Pune Aundha Nagnath",
    description: "Temple cab Pune Aundha Nagnath service provides affordable and convenient transportation for passengers traveling between Pune and Aundha Nagnath for temple darshan and pilgrimage travel. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for pilgrims, family travelers, religious tourism trips, and spiritual travel requirements. Flexible booking options allow convenient temple cab reservations."
  }
],

tableData: [
  ["Pune to Aundha Nagnath Cab", "Pune to Aundha Nagnath Taxi"],
  ["Cab from Pune to Aundha Nagnath", "Taxi from Pune to Aundha Nagnath"],
  ["Pune to Aundha Nagnath Cab Service", "Pune to Aundha Nagnath Taxi Fare"],
  ["Pune to Aundha Nagnath One Way Cab", "Pune to Aundha Nagnath Round Trip Taxi"],
  ["Pune to Aundha Nagnath Cab Booking", "Cheap Pune to Aundha Nagnath Cab"],
  ["Best Pune to Aundha Nagnath Taxi", "Sedan Pune to Aundha Nagnath Cab"],
  ["SUV Pune to Aundha Nagnath Taxi", "Innova Pune to Aundha Nagnath Cab"],
  ["Temple Cab Pune Aundha Nagnath", "Pune to Aundha Nagnath Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Aundha Nagnath Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Aundha Nagnath cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe pilgrimage travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Aundha Nagnath Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Aundha Nagnath cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Aundha Nagnath Cab Availability",
        WhyChoosedescription: "Our Pune to Aundha Nagnath cab service operates 24 hours a day for temple visits, Jyotirlinga darshan, family pilgrimages, religious tours, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance pilgrimage travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Aundha Nagnath taxi service, round-trip bookings, Jyotirlinga tours, and customized pilgrimage travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for pilgrims, families, senior citizens, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Aundha Nagnath highway routes and ensure safe driving, smooth travel, and timely darshan for every spiritual journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Aundha Nagnath cab service?", answer: "Pune to Aundha Nagnath cab service provides comfortable taxi transportation between Pune and Aundha Nagnath for temple visits and Jyotirlinga pilgrimage tours." },
    { question: "Is Pune to Aundha Nagnath cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Aundha Nagnath cab service." },
    { question: "Which vehicles are available for Pune to Aundha Nagnath travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Aundha Nagnath?", answer: "Yes, customers can book one-way as well as round-trip Pune to Aundha Nagnath taxi services." },
    { question: "Do you provide Jyotirlinga tour taxi packages?", answer: "Yes, Shivai Travels provides Jyotirlinga sightseeing and customized pilgrimage travel packages." },
    { question: "Are all Pune to Aundha Nagnath taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable pilgrimage travel." },
    { question: "Can I book Pune to Aundha Nagnath cab service online?", answer: "Yes, customers can easily book Pune to Aundha Nagnath cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group pilgrimage tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group pilgrimage travel." },
    { question: "Are Pune to Aundha Nagnath cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Aundha Nagnath cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Deshmukh",
    feedback:
      "Had a smooth Pune to Aundha Nagnath cab journey with a comfortable vehicle and a professional driver who ensured a safe and peaceful pilgrimage experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "The Pune to Aundha Nagnath taxi service was very reliable with timely pickup, clean car, and a stress-free travel experience throughout the long journey.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Aundha Nagnath Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-aundha-nagnath-cab.jpg",
  "description": "Book Pune to Aundha Nagnath Cab Service for safe and comfortable Jyotirlinga temple travel. Shivai Travels offers reliable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for pilgrimage and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-aundha-nagnath-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Aundha Nagnath Cab Service | Jyotirlinga Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Aundha Nagnath cab service for safe Jyotirlinga pilgrimage travel. Affordable one-way and round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pune to aundha nagnath cab, pune to aundha nagnath taxi, cab from pune to aundha nagnath, taxi from pune to aundha nagnath, pune to aundha nagnath cab service, pune to aundha nagnath taxi fare, pune to aundha nagnath one way cab, pune to aundha nagnath round trip taxi, pune to aundha nagnath cab booking, cheap pune to aundha nagnath cab, best pune to aundha nagnath taxi, sedan pune to aundha nagnath cab, suv pune to aundha nagnath taxi, innova pune to aundha nagnath cab, temple cab pune aundha nagnath"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoaundhnagnathcab;